import React from 'react';
import './TrustBar.css';

const features = [
  {
    id: 1,
    title: 'Free Shipping',
    desc: 'Enjoy fast and secure delivery across India on qualifying orders.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <rect x="1" y="3" width="15" height="13" rx="1" />
        <path d="M16 8h4l3 5v4h-7V8z" />
        <circle cx="5.5" cy="18.5" r="2.5" />
        <circle cx="18.5" cy="18.5" r="2.5" />
      </svg>
    ),
  },
  {
    id: 2,
    title: 'Money Guarantee',
    desc: 'Shop confidently with our hassle-free return and refund policy.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        <polyline points="9 12 11 14 15 10" />
      </svg>
    ),
  },
  {
    id: 3,
    title: 'Dedicated Online Support',
    desc: 'Our team is always ready to assist you with product guidance and help.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>
    ),
  },
  {
    id: 4,
    title: 'Cash on Delivery Available',
    desc: 'Pay safely at your doorstep with easy cash-on-delivery service.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="5" width="20" height="14" rx="2" />
        <line x1="2" y1="10" x2="22" y2="10" />
      </svg>
    ),
  },
];

const TrustBar = () => {
  return (
    <section className="tb-section">
      <div className="tb-inner">
        {features.map((f, i) => (
          <div className="tb-item" key={f.id}>
            <div className="tb-icon-wrap">
              {f.icon}
            </div>
            <div className="tb-content">
              <h3 className="tb-title">{f.title}</h3>
              <p className="tb-desc">{f.desc}</p>
            </div>
            {i < features.length - 1 && <div className="tb-divider" />}
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrustBar;